module.exports = __webpack_public_path__ + "img/rank-3.b0f3cf5f.svg";